import React from 'react';
import { TextType } from './text.types';
import classnames from 'classnames';
import './text.scss';

interface Props {
  children: React.ReactNode;
  type: TextType;
  bold?: boolean;
  uppercase?: boolean;
  inline?: boolean;
}

export function Text({ children, type, bold, inline, uppercase }: Props): JSX.Element {
  return (
    <div
      className={classnames('text', type && `text--${type}`, {
        'text--bold': bold,
        'text--inline': inline,
        'text--uppercase': uppercase,
      })}
    >
      {children}
    </div>
  );
}
